export const SEARCH_VERSION = 1;
